import React, { useState, useEffect, useRef } from 'react';
import { SFuncModal, STitle, SLowcodeList } from 'shj-components'
import { Button, Card, message, Splitter, Space, Spin, InputNumber } from 'antd';
import { RollbackOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { planCommonControllerRule, variableRetrieval, planCommonFindSpecialRuleVariableById } from '@/services/fmsConfig'
export function modalCodeFn({ fn, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };

    const dialog = SFuncModal({
        title: `取数规则`,
        width: 1000,
        vanish: true,
        content: <ModalCode onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}
const ModalCode = ({ onClose, fn, ...rest }) => {
    // console.log(rest)
    const listRef = useRef<any>();
    const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
    const [variable, setVariable] = useState([] as any);//变量
    const [rulefunction, setRuleFunction] = useState([{
        name: '且',
        value: '&&',
        disabled: false
    }, {
        name: '或',
        value: '||',
        disabled: false
    }, {
        name: '(',
        value: '(',
        disabled: false
    }, {
        name: ')',
        value: ')',
        disabled: false
    }, {
        name: '=',
        value: '==',
        disabled: false
    }, {
        name: '≠',
        value: '!=',
        disabled: false
    }, {
        name: '>',
        value: '>',
        disabled: false
    }, {
        name: '<',
        value: '<',
        disabled: false
    }, {
        name: '<=',
        value: '<=',
        disabled: false
    }, {
        name: '>=',
        value: '>=',
        disabled: false
    }]);//函数
    const [variableGet, setVariableGet] = useState('');//变量取数 ''为输入，否则列表选择
    const [codeList, setCodeList] = useState([] as any);//公式数组 value
    const [codeLabelList, setCodeLabelList] = useState([] as any);//公式数组 label
    const [inputValue, setInputValue] = useState('');
    const [config, setConfig] = useState({
        pagination: false,
        fieldControl: false,
        rowSelectionType: 'radio',
        tableType: 'antd',
        size: 'small',
        rowKey: 'code',
        columns: [
            {
                title: '名称',
                dataIndex: 'desc',
            }
        ],
        search: [
            {
                name: 'itemName',
                label: '名称',
                width: '300px',
            }
        ]
    });//变量取数配置
    useEffect(() => {
        if(rest.code){
            setCodeList(rest.code.split(' '))
            setCodeLabelList(rest.desc.split(' '))
        }
        initFn();
    }, []);

    useEffect(() => {
        console.log('codeList', codeList)
    }, [codeList]);

    const initFn = () => {
        setAddOrEditFooterLoading(true)
        if(rest.ruleType && rest.ruleType === 'special'){
            planCommonFindSpecialRuleVariableById(rest.programmeId).then(res => {
                setVariable(res)
                setAddOrEditFooterLoading(false)
            })
        }else{
            planCommonControllerRule({fetchTypeCode: rest.fetchTypeCode}).then(res => {
                setVariable(res)
                setAddOrEditFooterLoading(false)
            })
        }
    };
    // 撤销
    const onReset = () => {
        if (codeList.length > 0) {
            setCodeList(prevList => prevList.slice(0, -1));
            setCodeLabelList(prevList => prevList.slice(0, -1));
        }
    };

    // 清除
    const onDelete = () => {
        setCodeList([]);
        setCodeLabelList([]);
    };

    // 添加项目到列表
    const addToLists = (value, name) => {
        setCodeList(prevList => [...prevList, value]);
        setCodeLabelList(prevList => [...prevList, name]);
    };
    // 变量
    const onVariable = (item) => {
        setVariableGet('')
        setTimeout(()=>{
            setVariableGet(item.link)
            if(item.fields){
                const updatedFields = item.fields.map(m => ({
                    ...m,
                    title: m.desc,
                    dataIndex: m.code
                }));
                setConfig({
                    ...config,
                    columns: updatedFields,
                    search: item.code === 'oderInfo' ? [
                        {
                            name: 'itemName',
                            label: '订单号',
                            width: '400px',
                        } 
                    ]: [
                        {
                            name: 'itemName',
                            label: '名称',
                            width: '300px',
                        }
                    ]
                });
            }
            addToLists(item.code, item.desc);
        },100)
    };

    // 函数
    const onRuleFunction = (item) => {
        addToLists(item.value, item.name);
    };

    // 添加变量值
    const onAdd = () => {
        if (variableGet) {
            const [rowKeys, rows] = listRef?.current?.getSelectedRows() || [[], []];
            if (rowKeys.length < 1) {
                message.warning('至少选择一条数据!');
                return;
            }
            //取数金额和报价面积 不需要'',其他类型需要
            if(variableGet.includes('fetchAmountTypes') || variableGet.includes('quotationArea')){
                addToLists(rows[0].code, rows[0].desc);
            }else{
                console.log('code', "\'" + rows[0].code + "\'")
                addToLists("\'" + rows[0].code + "\'", rows[0].desc);
            }
        } else {
            addToLists(inputValue, inputValue);
        }
    };
    const handleInputChange = (e) => {
        // setInputValue(e.target.value);
        setInputValue(e);
    };
    // 提交
    const onSubmit = () => {
        if (codeList.length === 0) {
            message.warning('公式不能为空');
            return;
        }

        // 检查括号是否配对
        let bracketCount = 0;
        for (const item of codeList) {
            if (item === '(') bracketCount++;
            if (item === ')') bracketCount--;
            // 右括号数量大于左括号，表示不合法
            if (bracketCount < 0) {
                message.warning('括号使用不合法');
                return;
            }
        }
        // 最终左括号数量应该等于右括号数量
        if (bracketCount !== 0) {
            message.warning('括号必须成对出现');
            return;
        }

        // 检查是否有连续的变量、变量取数或函数
        for (let i = 0; i < codeList.length - 1; i++) {
            const current = codeList[i];
            const next = codeList[i + 1];
            // 检查运算符
            const operators = ['&&', '||', '==', '!=', '>', '<', '<=', '>='];
            const isCurrentOperator = operators.includes(current);
            const isNextOperator = operators.includes(next);
            // 检查括号
            const brackets = ['(', ')'];
            const isCurrentBracket = brackets.includes(current);
            const isNextBracket = brackets.includes(next);
            if (isCurrentOperator && isNextOperator) {
                message.warning('运算符不能连续使用');
                return;
            }
            if (!isCurrentOperator && !isCurrentBracket && !isNextOperator && !isNextBracket) {
                message.warning('变量之间必须有运算符');
                return;
            }
        }
        onClose();
        fn && fn({
            code: codeList,
            desc: codeLabelList,
        });
    };
    // 表格加载
    const fetchList = (values: any) => {
        const { current, pageSize, ...rest } = values;
        return new Promise(async (resolve, reject) => {
            const { query } = values;
            try {
                variableRetrieval(variableGet, query).then((res) => {
                    resolve({ records: res })
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const extension = {
        request: { fetchList },
        // 如果需要，在这里添加其他属性
    };
    return (<Spin spinning={addOrEditFooterLoading}>
        <div style={{ padding: 15 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', background: '#f0f2f5', borderRadius: 5, padding: 10 }}>
                <div>公式</div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div onClick={onReset} style={{ cursor: 'pointer' }}>
                        <RollbackOutlined />
                        <span style={{ marginLeft: 2 }}>撤销</span>
                    </div>
                    <div onClick={onDelete} style={{ marginLeft: 10, cursor: 'pointer' }}>
                        <CloseCircleOutlined />
                        <span style={{ marginLeft: 2 }}>清空</span>
                    </div>
                </div>
            </div>
            <Card style={{ margin: '5px 0px' }}>
                <p>{codeLabelList.join(' ')}</p>
            </Card>
            <Splitter style={{ height: 400, boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', }}>
                <Splitter.Panel  style={{ padding: 5 }} defaultSize="28%" min="20%" max="40%">
                    <STitle title='变量' />
                    <div style={{ marginTop: 10 }}>
                        {
                            variable.map((item, index) => {
                                return (
                                    <Button color="danger" variant="filled" size="small" onClick={() => onVariable(item)}
                                        style={{ marginRight: 4, marginBottom: 4 }}>
                                        {item.desc}
                                    </Button>
                                )
                            })
                        }
                    </div>

                </Splitter.Panel>
                <Splitter.Panel style={{ padding: 5 }} defaultSize="12%" min="10%" max="20%">
                    <STitle title='函数' />
                    <div style={{ display: 'flex', marginTop: 10, flexWrap: 'wrap' }}>
                        {
                            rulefunction.map((item, index) => {
                                return (
                                    <Button onClick={() => onRuleFunction(item)} color="default" disabled={item.disabled} variant="filled" size="small"
                                        style={{ marginRight: 4, width: 40, marginBottom: 4 }}>
                                        {item.name}
                                    </Button>
                                )
                            })
                        }
                    </div>
                </Splitter.Panel>
                <Splitter.Panel style={{ padding: 5 }} defaultSize="60%" min="55%" max="70%">
                    <STitle title='变量取数' />
                    {
                        !variableGet ? <Space direction="horizontal" style={{ marginTop: 10 }}>
                            <InputNumber
                                style={{width: 150}}
                                placeholder="请输入变量取数"
                                onChange={handleInputChange}
                            />
                            <Button style={{ width: 80 }} onClick={onAdd}>
                                添加
                            </Button>
                        </Space> : <>
                            <div style={{ height: 320, overflow: 'auto' }}>
                                <SLowcodeList config={config} ref={listRef} {...extension} size="small" searchMode="group" />
                            </div>
                            <Button style={{ float: 'right', marginTop: 10 }} onClick={onAdd}>添加</Button>
                        </>
                    }

                </Splitter.Panel>
            </Splitter>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                <Button color="primary" type="primary" style={{ marginTop: 10 }} onClick={onSubmit}>提交</Button>
            </div>
        </div>
    </Spin>
    );
};
